module.exports = __webpack_public_path__ + "static/media/hotel.1ea84845.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/hotel.jpg
// module id = 573
// module chunks = 6